import { AllWorkflows } from "@circle-react/components/SettingsApp/Workflows/routes/AllWorkflows";

export const WorkflowsTab = () => (
  <div className="h-[60vh] overflow-scroll px-2 pt-3">
    <AllWorkflows category="paywalls" pageSize={3} />
  </div>
);
